<template>
  <div class="wxConfigContainer">
    <div class="wxConfigShowArea">
      <div class="wxConfigArea">
        <h2 class="title">微信公众号配置</h2>
        <el-form label-width="180px" label-position="left" class="settingForm" :model="form" :rules="formRules"
                 v-loading="loading">
          <el-form-item label="微信认证文件">
            <el-row>
              <el-col :span="19">
                <el-input v-model="form.txtName" :disabled="true" placeholder="请上传微信认证文件"></el-input>
              </el-col>
              <el-col :offset="1" :span="4">
                <el-upload label-position="left" :show-file-list="false" accept=".txt"
                          :action="`${baseUrlAddr}/admin/wxConfig/txt`" :on-exceed="uploadExceed"
                          :before-upload="beforeUpload" :on-success="uploadSuccess" :on-error="uploadError">
                  <el-tooltip class="item" effect="dark" content="只能上传txt文件，例如：MP_verify_xxxxxxxxxxx.txt" placement="right">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-tooltip>
                  <!-- <el-button size="small" type="primary">点击上传</el-button> -->
                  <!-- <div slot="tip" class="el-upload__tip">只能上传txt文件，例如：MP_verify_xxxxxxxxxxx.txt</div> -->
                </el-upload>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="appId">
            <el-input v-model="form.appId" placeholder="请输入公众号appId"></el-input>
          </el-form-item>
          <el-form-item label="appsecret">
            <el-input v-model="form.secret" placeholder="请输入公众号appsecret"></el-input>
          </el-form-item>
          <el-form-item label="报警模板ID">
            <el-input v-model="form.alarmTemplateId" placeholder="请输入报警模板ID"></el-input>
          </el-form-item>
          <el-form-item label="故障模板ID">
            <el-input v-model="form.faultTemplateId" placeholder="请输入故障模板ID"></el-input>
          </el-form-item>
          <el-form-item label="微信回调URL">
            <el-input v-model="form.redirectUri" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="saveBtn" align="center" type="primary" @click="save">保存配置</el-button>
          </el-form-item>
        </el-form>
        <!-- <div class="urlShowBox" v-if="serviceUrl"><span>服务地址：</span><em>{{serviceUrl}}</em></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: true,
      form: {
        id: '',
        txtName: '',
        appId: '',
        secret: '',
        alarmTemplateId: '',
        faultTemplateId: '',
        redirectUri: ''
      },
      formRules: {},
      serviceUrl: ''
    };
  },
  created() {
    this.queryConfig()
    this.queryUrl()
  },
  methods: {
    queryConfig() {
      this.request.get("/admin/wxConfig/query").then(res => {
        console.log(res);
        if (res.code !== 200) {
          this.loading = false
          return false
        }
        if (res.data) {
          this.loading = false
          this.form = {
            id: res.data.id,
            txtName: res.data.txtName,
            appId: res.data.appId,
            secret: res.data.secret,
            alarmTemplateId: res.data.alarmTemplateId,
            faultTemplateId: res.data.faultTemplateId,
            redirectUri: res.data.redirectUri
          }
        } else {
          this.queryUrl()
        }
      });
    },
    queryUrl() {
      this.request.get("/admin/wxConfig/getRedirectUri").then(res => {
        console.log(res);
        this.loading = false
        if (res.code !== 200) {
          return false
        }
        this.form.redirectUri = res.data
      });
    },
    save() {
      let params = Object.assign({}, this.form)
      this.request.postParamsData("/admin/wxConfig/update", params).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.msg.success('操作成功');
        } else {
          this.msg.error(res.msg);
        }
      });
    },
    beforeUpload(file) {
      const isTXT = file.type === 'text/plain';
      if (!isTXT) {
        this.$message.error('上传文件只能是 TXT 格式!');
        return false;
      }
      const isLt2K = file.size / 1024 < 2;
      if (!isLt2K) {
        this.$message.error('上传文件大小不能超过 2KB!');
        return false;
      }
      return true;
    },
    uploadSuccess(response, file, fileList) {
      if (fileList.length > 0) {
        this.form.txtName = fileList[0].name
      }
      this.$message.success('上传成功');
    },
    uploadError(err, file, fileList) {
      this.$message.error(err);
    },
    uploadExceed() {
      this.$message.error('只能上传一个文件');
    }
  }
};
</script>

<style lang="scss" scoped>
.wxConfigContainer {
  width: 100%;
  overflow: auto;
  position: absolute;
  height: 96%;
  padding: 20px;
  border-radius: 4px;
  box-sizing: border-box;

  .wxConfigShowArea {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px;
    overflow: auto;
    box-sizing: border-box;

    .wxConfigArea {
      width: 100%;
      min-height: 100%;
      background: #fff;
      padding: 20px;
      box-sizing: border-box;
    }
  }

  .title {
    font-size: 30px;
    color: #333;
    padding: 0 10px 10px;
  }

  .settingForm {
    margin-top: 20px;
    padding: 0 87px;

    .el-form-item {
      width: 660px;
    }
  }

  .urlShowBox {
    margin-top: 50px;
    padding: 0 87px;
    font-size: 24px;

    span {
      display: inline-block;
      width: 180px;
    }

    em {
      font-weight: bold;
    }
  }
}

.saveBtn {
  width: 400px;
  background: #2662dc;
}
</style>
